import $ from 'jquery';

export default function () {

    $('.js-popup-cta-open').click(function (e) {

        e.preventDefault();
        $('.js-popup-cta').addClass('is-active');

    });

    $('.js-popup-cta-close').click(function () {

        $('.js-popup-cta').removeClass('is-active');

    });

    $('.js-response-cta-close').click(function () {

        $('.js-response-cta').removeClass('is-active');
        sessionStorage.removeItem('status');

    });

    // gallery popup open
    const galleryItem = $('.js-card-gallery');
    galleryItem.each(function() {
        const $this = $(this);
        const galleryPopup = $this.next('.js-gallery-popup');

        $this.click(function (event) {
            event.preventDefault();
            galleryPopup.addClass('is-active');
        });
    });

    // gallery popup close
    $('.js-gallery-popup-back').click(function (event) {
        event.preventDefault();
        const galleryPopupItem = $('.js-gallery-popup');
        console.log('work');

        galleryPopupItem.each(function() {
            $(this).removeClass('is-active');
        });
    });

}
